module.exports = __webpack_public_path__ + "page-not-found.e430101033efff9a294e.gif";


//////////////////
// WEBPACK FOOTER
// /home/agira/Desktop/BU-Intra/agira-intranet-ui/src/assets/img/page-not-found.gif
// module id = ../../../../../src/assets/img/page-not-found.gif
// module chunks = main